import { Spinner } from "phosphor-react";
import React from "react";
import colors from "../../utils/constants/COLORS";
import SpinnerStyle from "../Styled/Spinner.style";

export default function Loading() {
  return (
    <SpinnerStyle>
      <Spinner size={14} weight="thin" color={colors.secondary} />
    </SpinnerStyle>
  );
}
